module.exports = __webpack_public_path__ + "static/media/VRED Core.d594a05f.png";